// Contact.js
import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };

  return (
  <div className="bg-orange-300">
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Contact Me</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <p className="text-lg mb-4">Feel free to reach out to me via email at <a href="mailto:ramodixit76@gmail.com" className="text-blue-500 font-semibold">ramodixit76@gmail.com</a>, or submit the form below:</p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" className="border border-gray-300 rounded-md p-3" />
          <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" className="border border-gray-300 rounded-md p-3" />
          <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Message" rows="5" className="border border-gray-300 rounded-md p-3"></textarea>
          <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Submit</button>
        </form>
      </div>
    </div>
  </div>
  );
};

export default Contact;
